import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { BaseGenDocTypeService } from './base-generic-doc-hdr.service';

@Injectable({ providedIn: 'root' })
export class InternalInboundDeliveryOrderService extends BaseGenDocTypeService {

    constructor(http: HttpClient) {
        super(http, 'internal-inbound-delivery-orders');
    }

    getLinesByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocContainerModel>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
        }
        const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
    }

    getLinesByCriteriaPromise(pagination: Pagination, visa: ApiVisa): Promise<PagingResponseModel<GenericDocContainerModel>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
        }
        const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa)).toPromise();
    }

    public printJasperPdf(
        guid: string,
        printServiceClassName: string,
        printableFormatGuid: string,
        apiVisa: ApiVisa,
        customParam?: string): Observable<Blob> {
        let params;
        let url;
        if (customParam) {
            params = new HttpParams()
                .set('printServiceClassName', printServiceClassName)
                .set('printableFormatHdrGuid', printableFormatGuid)
                .set('customParam', customParam);
        } else {
            params = new HttpParams()
                .set('printServiceClassName', printServiceClassName)
                .set('printableFormatHdrGuid', printableFormatGuid);
        }
        url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
        return this.httpClient.get<Blob>(
            url,
            this.getHttpHeaderBlob(apiVisa, params)
        );
    }

}
